module.exports = __webpack_public_path__ + "static/07-TUN-BOUKHA.2ac5a7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/07-TUN-BOUKHA.png
// module id = 601
// module chunks = 35783957827783